import { useState, useEffect } from 'react';
import axios from '../utils/axios';

const DiamondExchange = () => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        try {
            const { data } = await axios.get('/settings');
            setContent(data.diamondExchange || 'İçerik hazırlanıyor...');
        } catch (error) {
            setContent('İçerik yüklenemedi.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="max-w-4xl mx-auto px-4 py-16">
                <div className="flex items-center justify-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20">
                <h1 className="font-serif text-4xl md:text-5xl font-light tracking-wide text-center mb-16">
                    Pırlanta Değişim
                </h1>
                <div className="prose prose-lg max-w-none">
                    <div
                        className="text-gray-600 font-light leading-relaxed whitespace-pre-wrap"
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                </div>
            </div>
        </div>
    );
};

export default DiamondExchange;
